var a={mainWrapper:"rl2_appDownloadButtons-module_mainWrapper_zcukx",badgesWrapper:"rl2_appDownloadButtons-module_badgesWrapper_80wtY",appStoreBadge:"rl2_appDownloadButtons-module_appStoreBadge_Ofxgy"};export{a as default};
